'use client';

import { useCallback } from 'react';
import Checkbox from 'components/gruenland/atoms/checkbox';
import { useProductList } from '../../context';
import { Term as TermType } from '../../types';

const TermFacetItem: React.FC<{ attribute: string; term: TermType }> = ({ attribute, term }) => {
  const { refine } = useProductList();
  const handleChange = useCallback(() => {
    refine(attribute, term.key);
  }, [attribute, refine, term]);
  return (
    <Checkbox
      defaultChecked={term.selected}
      onChange={handleChange}
      label={
        <>
          {term.label} {term.count > 0 && <small>({term.count})</small>}
        </>
      }
      labelPosition="on-right"
    />
  );
};

export default TermFacetItem;
